<template functional>
  <div class="cart-summary">
    <div class="content">
      <!--
        @slot intended for CartList
      -->
      <slot name="content" />
    </div>
    <div class="footer">
      <div class="total">
        <!--
          @slot content for the total price of items in the bag
        -->
        <slot name="total" :label="props.totalLabel" :text="props.totalText">
          <label>{{ props.totalLabel }}</label>
          {{ props.totalText }}
        </slot>
      </div>
      <template v-if="props.loyaltyPointText">
        <div class="loyalty-points">
          <!--
            @slot content for the loyalty points the user currently have
          -->
          <slot
            name="loyalty-points"
            :label="props.loyaltyPointLabel"
            :text="props.loyaltyPointText"
          >
            <label>{{ props.loyaltyPointLabel }}</label>
            {{ props.loyaltyPointText }}
          </slot>
        </div>
      </template>
      <div class="view-cart-button">
        <!--
          @slot button to redirect user to the cart page or any other page
        -->
        <slot name="view-cart-button" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CartSummary',
  props: {
    /** label to indicate the value next to is the total price */
    totalLabel: {
      type: String,
      required: true
    },
    /** the total price of the items in the bag */
    totalText: {
      type: String,
      required: true
    },
    /** label to indicate the value next to is the loyalty points the user have  */
    loyaltyPointLabel: {
      type: String
    },
    /** the loyalty points the user currently have */
    loyaltyPointText: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/components/level';

.cart-summary {
  padding-top: 5px;
}

.footer {
  background-color: $white;
  border-top: 1px solid $grey-darker;
  padding-left: 17px;
  padding-right: 17px;
  padding-bottom: 20px;

  .total,
  .loyalty-points,
  .view-cart-button {
    display: flex;
    justify-content: center;
    line-height: 20px;
  }
}

.total {
  margin-top: 17px;
  margin-bottom: 5px;
  line-height: 20px;
  font-size: 20px;
  font-weight: 700;
  text-transform: uppercase;

  label {
    margin-right: 5px;
  }
}

.loyalty-points > label {
  margin-right: 5px;
}

.view-cart-button {
  margin-top: 25px;
}
</style>
